import { t } from '../../i18next';
import { getApiBaseUrl } from '../../shared/utils/apiBase';
import { LoginContext } from './loginContext';

// TODO: Move this function to ui-components
export async function sessionMiddleware({ context, request }) {
  const apiBase = getApiBaseUrl();
  const response = await fetch(`${apiBase}/api/auth/session`, {
    method: 'GET',
    headers: { Accept: 'application/json' },
  });

  let payload = { data: null, error: '' };
  try {
    payload = await response.json();
  } catch {}

  if (response.ok) {
    context.set(LoginContext, payload.data);
  } else {
    const stateParam = btoa(encodeURIComponent(request.url));
    switch (payload?.error) {
      case 'Token expired':
        const messageQuery = `?message=${t('error.invalid_session')}&state=${stateParam}`;
        window.location.href = `/login${messageQuery}`;
        break;
      default:
        window.location.href = `/login?state=${stateParam}`;
    }
    throw new Error('Unauthorized');
  }
}
